@if (
  (formErrors() === null && schemaErrors() === null) &&
  (schema$ | async)
) {
  <div class="flex flex-column col-12" style="height: 100%;">
    @if ((schema$ | async) && formReady()) {
      <form [formGroup]="parentForm" class="col-12" style="height: 100%;">
        @switch (renderMode) {
          @case ('quickSettings') {
            @if (schema$ | async; as schema) {
              <sfo-quicksettings-view
                [schema]="schema"
                [aFormControl]="parentForm"
              ></sfo-quicksettings-view>
            }
          }
          @case ('simple') {
            @if (schema$ | async; as schema) {
              <sfo-simple-view [schema]="schema" [aFormControl]="parentForm"></sfo-simple-view>
            }
          }
          @case ('tabbed') {
            @if (schema$ | async; as schema) {
              <sfo-tab-view
                [schema]="schema"
                [aFormControl]="parentForm"
                [activeTab]="activeTab"
              ></sfo-tab-view>
            }
          }
          @default {
            @if (schema$ | async; as schema) {
              <sfo-drawer-view [schema]="schema" [aFormControl]="parentForm"></sfo-drawer-view>
            }
          }
        }
      </form>
    } @else if ((schema$ | async) && formReady() !== true) {
      <div class="col-12 p-4">
        <p>Initializing form...</p>
      </div>
    }
  </div>
} @else {
  <div class="flex flex-column col-12 justify-center items-center" style="height: 100%;">
    @if (formErrors(); as error) {
      <sfo-admonition type="danger" title="Form Error" expanded hideToggle>
        <span>{{error}}</span>
      </sfo-admonition>
    }

    @if (schemaErrors(); as error) {
      <sfo-admonition type="danger" title="Schema Error" expanded hideToggle>
        <span>{{error}}</span>
      </sfo-admonition>
    }
  </div>
}
